// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"4c296fbc46ed403e37b28c39ba9ff09b1235c225"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://6a653b0970ed9ef56c3500b3cad92b47@o4508307020709888.ingest.us.sentry.io/4508307027329024",

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});
